import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationModalConfig, ConfirmationModalEventData } from '@models/modal.model';
import { TranslationService } from '@services/translation/translation.service';
import { DomSanitizerPipe } from 'tangoe-design-system';

@Component({
  selector: 'ts-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  imports: [CommonModule, DomSanitizerPipe]
})
export class ConfirmationModalComponent {
  @Input() config: ConfirmationModalConfig = {} as ConfirmationModalConfig;
  @Output() action_event = new EventEmitter<ConfirmationModalEventData>();

  constructor(private translation_svc: TranslationService) {}

  title(): string {
    return this.config.title ? this.config.title : '';
  }

  message(): string {
    return this.config.message ? this.config.message : '';
  }

  hideConfirmMessage(): boolean {
    return this.config.hide_confirm_message ? this.config.hide_confirm_message : false;
  }

  confirmMessage(): string {
    return this.config.confirm_message
      ? this.config.confirm_message
      : this.translation_svc.translate('do_you_want_to_continue');
  }

  confirmButtonText(): string {
    return this.config.confirm_button_text
      ? this.config.confirm_button_text
      : this.translation_svc.translate('yes');
  }

  cancelButtonText(): string {
    return this.config.cancel_button_text
      ? this.config.cancel_button_text
      : this.translation_svc.translate('no');
  }

  compact(): boolean {
    return this.config.compact || false;
  }

  modalData(): ConfirmationModalConfig['modal_data'] {
    return this.config.modal_data;
  }

  userAction(action: ConfirmationModalEventData['action']) {
    this.action_event.emit({ action, data: this.modalData() });
  }
}
